import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const ProcedureDataTitle = styled.p`
    margin: 8px 0;
    font-family: 'AvenirNextWorld Bold';
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0px;
    color: #130e4a;
    opacity: 1;
    ${media.mobileDevice`
        margin-top: 3%;
        margin-bottom: 18px;
        margin-left: ${({ isCondensedView }) => isCondensedView && '15px'};
    `}
`;

export const Container = styled.div`
    display: none;
    ${media.mobileDevice`
       display:block;
    `}
`;

export const Title = styled.div`
    font-family: AvenirNextWorld Demi;
    color: ${({ color }) => (color ? color : '#130E4A')};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '15px')};
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '0px'};
    cursor: ${({ cursor }) => (cursor ? cursor : ' ')};
    ${media.mobileDevice`
    `}
`;

export const Subtitle = styled.div`
    font-family: 'AvenirNextWorld Regular';
    color: ${({ color }) => (color ? color : '#000000')};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '11px')};
    width: ${({ width }) => (width ? width : '100%')};
    display:block;
    ${media.mobileDevice`
       width:${({ mbWidth }) => (mbWidth ? mbWidth : '100%')};
       color: ${({ color }) => (color ? color : '#202124')};
       font-size: ${({ fontSize }) => (fontSize ? fontSize : '15px')};
       line-height: 20px;
       font-family: 'AvenirNextWorld Regular';
    `}
`;

export const MainContainerItems = styled.div`
    width: ${({ width }) => (width ? width : '47%')};
    height: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    padding: ${({ padding }) => (padding ? padding : '0rem')};
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '0px'};
      margin-top: ${({ marginTop }) =>
        marginTop ? marginTop : '0px'};
    word-break: break-word;

    ${media.largeDevice`
        width:${({ ldWidth }) => ldWidth && ldWidth};
        padding: ${({ ldPadding }) => (ldPadding ? ldPadding : '0rem')};
    `}

    ${media.mediumDevice`
        padding: ${({ mdPadding }) => (mdPadding ? mdPadding : '0rem')};
    `}

    ${media.smalDevice`
        padding: ${({ ipadPadding }) => (ipadPadding ? ipadPadding : '0.5rem')};
    `}
    ${media.mobileDevice`
        width: 100%;
        padding: ${({ mbPadding }) => (mbPadding ? mbPadding : '0rem')};     
    `}
`;

export const DisplayCard = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    height: 100%;
    width: 100%;
    background-color: #ffffff;
    box-shadow: 0px 0px 6px #00000029;
    border: none;
    border-radius: 6px;
    padding: ${({ padding }) => (padding ? padding : '15px 15px')};
    margin-bottom: 10px;
    ${media.mobileDevice`
    display:  ${({ display }) => (display ? display : 'flex')};
    border: 1px solid #74DED6;
    margin-bottom: 10px;
    `}
`;
export const ContainerItems = styled.div`
    width: 47%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '0px'};
    justify-content: space-between;
    ${media.mobileDevice`
        width: 88%;   
    `}
`;

export const Value = styled.div`
    display: flex;
    font-family: 'AvenirNextWorld Regular';
    color: ${({ color }) => (color ? '#ED002A' : '#000000')};
    font-size: 16px;
    width: 90%;
    ${media.mobileDevice`
    
    `}
`;

export const Div = styled.div`
    margin: 10px 0 0 0;
    ${media.mobileDevice`
        display:none;  
    `}
`;
export const BackorderText = styled.p`
    font-family: AvenirNextWorld Demi;
    font-size: 13px;
    color: ${({ color }) => (color ? color : '#000000')};
`;

export const HeadContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items:center;
    ${media.mobileDevice`
    display: flex;
    flex-direction: column;
    align-items:flex-start;
    `}
`;
export const TimeDiv = styled.span`
    font-family: AvenirNextWorld Demi;
    color: ${({ color }) => (color ? color : '#585858')};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '11px')};
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '0px'};
    cursor: ${({ cursor }) => (cursor ? cursor : ' ')};
    line-height: ${({ lineHeight }) => (lineHeight ? lineHeight : '19px')};
    ${media.mobileDevice`
`}
`;
